import Glider from 'glider-js/glider'; 

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {


    let sliderHome = document.querySelector('.home-glider');
    let progressiveBarRed = document.querySelector('.js-ProgressiveBarExtendible');
    let progressiveBar = document.querySelector('.js-ProgressiveBar');

    if (sliderHome){ 
      let homeSliderObj = new Glider(sliderHome, {
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.HomeSlider__Arrow--Sx.glider-prev',
          next: '.HomeSlider__Arrow--Dx.glider-next',
        },
      });

      
      if (homeSliderObj) {          
        document.addEventListener('glider-slide-visible', () => {
          onSlideChange();   
        });
      }

      const onSlideChange = () => {     
        let slidesCount = homeSliderObj.slides.length;
        let actual_id = document.querySelector('.js-homeSlider-id');
        let actual_num = +homeSliderObj.slide + 1;
        let totalHeight = progressiveBar.offsetHeight;
        actual_id.innerText = ('0' + actual_num);
        progressiveBarRed.style.height = ((totalHeight / slidesCount) * actual_num) + 'px';  
      }
    } 

    let sliderInModal = document.querySelector('.gliderModal');
    let modalSliderInstance;
    if (sliderInModal) {
      modalSliderInstance = new Glider(sliderInModal, {
        slidesToShow: 1,
        draggable: false,
        arrows: {
            prev: '.SliderModal__Arrow--Sx.glider-prev',
            next: '.SliderModal__Arrow--Dx.glider-next',
          },
      });

      sliderInModal.addEventListener('glider-slide-visible', evt => { 
        let modalTitle = document.querySelector('.js-modal-title');
        if(modalTitle){
          if(evt.detail.slide + 1 == modalSliderInstance.slides.length){
             modalTitle.innerText = modalTitle.dataset.formTitle;
            } else {
              modalTitle.innerText = modalTitle.dataset.modalTitle; 
          }
        }

        let actual_id = document.querySelector('.js-sliderModal-id'); 
        let actual_num = +evt.detail.slide + 1; 
        actual_id.innerText = ('0' + actual_num); 
      })


    }
    
    let allHtml = document.querySelector('html'); 
    //ModalHomeSlider
    let modal = document.querySelector('.js-ModalBlock'); 
    let openModal = document.querySelector('.js-modal');  
    let closenModal = document.querySelector('.js-ModalBlock-Close');  
    if(openModal){
      openModal.addEventListener('click', function() { 
        allHtml.style.overflow = 'hidden';
        modal.classList.add('is-modal-open');
      }) 
    }
    if(closenModal){
      closenModal.addEventListener('click', function(){
        closeModal();
      })              
    }

    const closeModal = () => {
      modalSliderInstance.scrollItem(0);
      modal.classList.remove('is-modal-open');
      allHtml.style.overflow = 'auto';
    }

    const catalogueForm = document.querySelector('.js-catalogue-form form');
    if (catalogueForm) {
      catalogueForm.addEventListener('hf-success', () => {
        setTimeout(() => {
          closeModal();
        }, 10000);
      })
    }

    let btnLink = document.querySelector('.js-startTour');
    btnLink.addEventListener('click', () => {
      let virtualTourOverlay = document.querySelector('.VirtualTour__Overlay');
      virtualTourOverlay.classList.add('starTour');
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js